import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgBreakReminder = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-default))"
        d="M59.976 5.776c-23.96-8.65-46.853-3.604-55.547 0-8.021 23.667-3.342 45.442 0 53.371 23.783 8.79 46.78 3.662 55.547 0 7.288-22.036 3.037-44.762 0-53.37"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M32 50.333c10.125 0 18.333-8.208 18.333-18.333S42.125 13.667 32 13.667 13.667 21.875 13.667 32c0 2.933.688 5.705 1.913 8.163.325.653.433 1.4.245 2.105l-1.092 4.081c-.474 1.772 1.146 3.392 2.918 2.918l4.081-1.092c.705-.188 1.452-.08 2.105.245A18.26 18.26 0 0 0 32 50.333"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M37.958 32c0-1.767-.002-2.955-.121-3.84-.114-.846-.311-1.208-.55-1.447s-.6-.436-1.447-.55c-.885-.119-2.073-.121-3.84-.121s-2.955.002-3.84.121c-.846.114-1.208.311-1.447.55s-.436.6-.55 1.447c-.119.885-.121 2.073-.121 3.84s.002 2.955.121 3.84c.114.846.311 1.208.55 1.447s.6.436 1.447.55c.885.119 2.073.121 3.84.121s2.955-.002 3.84-.121c.846-.114 1.208-.311 1.447-.55s.436-.6.55-1.447c.119-.885.121-2.073.121-3.84m2.75 0c0 1.69.003 3.096-.146 4.207-.155 1.151-.496 2.19-1.33 3.024-.836.835-1.874 1.176-3.025 1.33-1.111.15-2.517.147-4.207.147s-3.096.003-4.207-.146c-1.151-.155-2.19-.496-3.024-1.33s-1.176-1.874-1.33-3.025c-.15-1.111-.147-2.517-.147-4.207s-.003-3.096.146-4.207c.155-1.15.496-2.19 1.33-3.024s1.874-1.176 3.025-1.33c1.111-.15 2.517-.147 4.207-.147s3.096-.003 4.207.147c1.15.154 2.19.495 3.024 1.33s1.176 1.873 1.33 3.024c.15 1.111.147 2.518.147 4.207"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M48.958 32c0-9.366-7.592-16.958-16.958-16.958S15.042 22.634 15.042 32c0 2.715.637 5.278 1.769 7.55.454.912.628 2.003.341 3.074l-1.092 4.08a1.01 1.01 0 0 0 1.236 1.236l4.08-1.092c1.071-.287 2.162-.112 3.074.342l.865.4c2.05.88 4.309 1.368 6.685 1.368 9.366 0 16.958-7.592 16.958-16.958m2.75 0c0 10.885-8.823 19.708-19.708 19.708-3.15 0-6.132-.74-8.776-2.057-.395-.196-.797-.237-1.136-.147h-.001l-4.08 1.09c-2.794.748-5.35-1.807-4.602-4.6l1.09-4.08v-.003c.091-.338.05-.74-.146-1.135A19.6 19.6 0 0 1 12.292 32c0-10.884 8.823-19.708 19.708-19.708S51.708 21.116 51.708 32"
      />
    </svg>
  );
};
export default SvgBreakReminder;
